/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M431.088 380.873L305.406 255.19l125.012-125.012c13.504-13.504 13.486-35.39 0-48.875-13.486-13.486-35.371-13.504-48.875 0L256.53 206.316 130.849 80.634c-13.486-13.486-35.371-13.504-48.875 0-13.504 13.504-13.486 35.39 0 48.875l125.681 125.682L81.304 381.543c-13.504 13.504-13.486 35.389 0 48.875 13.486 13.486 35.371 13.504 48.875 0l126.352-126.352 125.681 125.682c13.486 13.486 35.371 13.504 48.876 0 13.504-13.504 13.485-35.39 0-48.875"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconClose = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconClose.defaultProps = {
  theme,
};
IconClose.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconClose.displayName = 'IconClose';
export { IconClose };
